// Styles here will override Bulma styles
import styled from '@emotion/styled';
import media from 'css-in-js-media';

export const StyledAuthor = styled.div`
  font-size: 16px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 20px 0 40px 0;
  color: rgba(51, 51, 51, 0.75);

  &.bloglist {
    font-size: 12px;
    margin: 6px 0;

    ${media('<desktop')} {
      display: none;
    }
  }

  ${media('<desktop')} {
    display: inline-block;
    min-height: 60px;
    margin: 0 0 10px 0;

    > div {
      display: block;
      height: 20px;
      position: relative;
      float: right;
      padding-top: 25px;
    }
  }

  a {
    color: hsl(215, 100%, 50%);
    margin: 5px 5px 0 5px;
  }

  a.tag,
  a.comment-count {
    margin-left: 5px;
  }

  img {
    border-radius: 50%;
    margin-right: 10px;
    object-fit: cover;
    max-width: 70px;
    width: 70px;
    height: 70px;

    ${media('<desktop')} {
      position: relative;
      top: 10px;
      max-width: 50px;
      width: 50px;
      height: 50px;
    }
  }
`;
